import { RosterPlanFiltersForm } from 'components/roster-portal/RosterPlan/RosterPlan.types';

export const FILTER_KEYS = [
  'costCenter',
  'function',
  'employees',
  'planned',
  'types',
  'qualifications',
  'dutyCodes',
  'dutyHourTypes',
  'absences',
  'costCenterOpenRequests',
  'functionOpenRequests',
  'qualificationsOpenRequests',
  'dutyCodesOpenRequests',
  'dutyHourTypesOpenRequests',
  'statusOpenRequests'
] as const;

export const EMPTY_ROSTER_PLAN_FILTERS: RosterPlanFiltersForm =
  Object.fromEntries(
    FILTER_KEYS.map((k) => [k, null])
  ) as RosterPlanFiltersForm;
